export default class BannerEnum {
    static VIDEO = '[data-banner-video]'
    static SLIDER = '[data-banner-slider]'
    static PAGINATION = '[data-pagination="banner-pagination"]'
}
